import Fuse from 'fuse.js';

const getInstanceAttributeKeys = (data) => {
    if (!data.instanceAttributes || typeof data.instanceAttributes !== 'object') {
        return [];
    }

    return Object.keys(data.instanceAttributes)
                .filter(key => typeof data.instanceAttributes[key] === 'string')
                .map(key => `instanceAttributes.${key}`);
};

export const toggleSearchSuggestions = (display) => {
    let search_suggestions = document.getElementById("search_suggestions")
    if (display) {
        search_suggestions.style.display = "block"
    } else {
        search_suggestions.style.display = "none"
    }
}

export const getSearchSuggestions = (newValue, data) => {
    const instanceFuse = new Fuse(data.data, {
        keys: getInstanceAttributeKeys(data.data[0]),
        threshold: 0.3, 
        findAllMatches: true,
        includeScore: true,
        includeMatches: true,
    });

    const instanceResult = instanceFuse.search(newValue).map(res => ({
        isInstance: true,
        id: res.item.instanceAttributes.id,
        attribute: res.matches[0].key.split('.').pop(),
        result: res.matches[0].value,
        score: res.score
    }));

    //Fuse search for group
    const groupList = [];
    for (const [key, value] of Object.entries(data["metadata"]["groupAttributes"])) {
        for (const term of value.vocab) {
            groupList.push({ term, attribute: key });
        }
    }

    const groupFuse = new Fuse(groupList, {
        keys: ['term'],
        includeScore: true,
        threshold: 0.3
    });        
    

    const groupResult = groupFuse.search(newValue).map(res => ({
        isInstance: false,
        id: (res.item.attribute + "." + res.item.term),
        attribute: res.item.attribute,
        result: res.item.term,
        score: res.score
    }))

    const searchResults = [...instanceResult, ...groupResult];

    // Sort the combined results by score in ascending order
    searchResults.sort((a, b) => a.score - b.score);

    return searchResults;
}

export const updateInputSuggestions = (e, data, setSearchResults, num_search_suggestions) => {
    const newValue = e.target.value;

    let search_suggestions = document.getElementById("search_suggestions")
    if (newValue.length > 2 && data) {
        // Fuse search for instance
        const result = getSearchSuggestions(newValue, data)

        if (result && result.length > 0) {
            search_suggestions.style.display = "block"
        } else {
            search_suggestions.style.display = "none"
        }

        setSearchResults(result.slice(0,num_search_suggestions));
    } else {
        search_suggestions.style.display = "none"
        setSearchResults([]);
    }
};